export const _watchJSON = () => {
    var result = [
        {
            "id": 5,
            "name": 'Apple Watch Series 5',
            "model_name": 'Apple-Watch-Series-5',
            "sName": 'Apple Watch Series 5',
            "image": 'apple.svg',
            "alt": 'iPad Repair Shop Near Me',
            "isChecked": false
        },
        {
            "id": 4,
            "name": 'Apple Watch Series 4',
            "model_name": 'Apple-Watch-Series-4',
            "sName": 'Apple Watch Series 4',
            "image": 'apple.svg',
            "alt": 'iPad Repair Shop Near Me',
            "isChecked": false
        },
        {
            "id": 3,
            "name": 'Apple Watch Series 3',
            "model_name": 'Apple-Watch-Series-3',
            "sName": 'Apple Watch Series 3',
            "image": 'apple.svg',
            "alt": 'iPad Repair Shop Near Me',
            "isChecked": false
        },
        {
            "id": 2,
            "name": 'Apple Watch Series 2',
            "model_name": 'Apple-Watch-Series-2',
            "sName": 'Apple Watch Series 2',
            "image": 'apple.svg',
            "alt": 'iPad Repair Shop Near Me',
            "isChecked": false
        },
        {
            "id": 1,
            "name": 'Apple Watch Series 1',
            "model_name": 'Apple-Watch-Series-1',
            "sName": 'Apple Watch Series 1',
            "image": 'apple.svg',
            "alt": 'iPad Repair Shop Near Me',
            "isChecked": false
        }
    ] 
    return result;
};

export const _iPhoneJSON = () => {
    var result = [
        {
            "id": 19,
            "name": 'iPhone 11 Pro Max',
            "model_name": 'iPhone-11-Pro-Max',
            "sName": 'iPhone 11 Pro Max',
            "image": 'apple.svg',
            "alt": 'iPad Repair Shop Near Me',
            "isChecked": false
        },
        {
            "id": 18,
            "name": 'iPhone 11 Pro',
            "model_name": 'iPhone-11-Pro',
            "sName": 'iPhone 11 Pro',
            "image": 'apple.svg',
            "alt": 'iPad Repair Shop Near Me',
            "isChecked": false
        },
        {
            "id": 17,
            "name": 'iPhone 11',
            "model_name": 'iPhone-11',
            "sName": 'iPhone 11',
            "image": 'apple.svg',
            "alt": 'iPad Repair Shop Near Me',
            "isChecked": false
        },
        {
            "id": 16,
            "name": 'iPhone XS Max',
            "model_name": 'iPhone-XS-Max',
            "sName": 'iPhone XS Max',
            "image": 'apple.svg',
            "alt": 'iPad Repair Shop Near Me',
            "isChecked": false
        },
        {
            "id": 15,
            "name": 'iPhone XS',
            "model_name": 'iPhone-XS',
            "sName": 'iPhone XS',
            "image": 'apple.svg',
            "alt": 'iPad Repair Shop Near Me',
            "isChecked": false
        },
        {
            "id": 14,
            "name": 'iPhone XR',
            "model_name": 'iPhone-XR',
            "sName": 'iPhone XR',
            "image": 'apple.svg',
            "alt": 'iPad Repair Shop Near Me',
            "isChecked": false
        },
        {
            "id": 13,
            "name": 'iPhone X',
            "model_name": 'iPhone-X',
            "sName": 'iPhone X',
            "image": 'apple.svg',
            "alt": 'iPad Repair Shop Near Me',
            "isChecked": false
        },
        {
            "id": 12,
            "name": 'iPhone 8 Plus',
            "model_name": 'iPhone-8-Plus',
            "sName": 'iPhone 8 Plus',
            "image": 'apple.svg',
            "alt": 'iPad Repair Shop Near Me',
            "isChecked": false
        },
        {
            "id": 11,
            "name": 'iPhone 8',
            "model_name": 'iPhone-8',
            "sName": 'iPhone 8',
            "image": 'apple.svg',
            "alt": 'iPad Repair Shop Near Me',
            "isChecked": false
        },
        {
            "id": 10,
            "name": 'iPhone 7 Plus',
            "model_name": 'iPhone-7-Plus',
            "sName": 'iPhone 7 Plus',
            "image": 'apple.svg',
            "alt": 'iPad Repair Shop Near Me',
            "isChecked": false
        },
        {
            "id": 9,
            "name": 'iPhone 7',
            "model_name": 'iPhone-7',
            "sName": 'iPhone 7',
            "image": 'apple.svg',
            "alt": 'iPad Repair Shop Near Me',
            "isChecked": false
        },
        {
            "id": 8,
            "name": 'iPhone 6s Plus',
            "model_name": 'iPhone-6s-Plus',
            "sName": 'iPhone 6s Plus',
            "image": 'apple.svg',
            "alt": 'iPad Repair Shop Near Me',
            "isChecked": false
        },
        {
            "id": 7,
            "name": 'iPhone 6s',
            "model_name": 'iPhone-6s',
            "sName": 'iPhone 6s',
            "image": 'apple.svg',
            "alt": 'iPad Repair Shop Near Me',
            "isChecked": false
        },
        {
            "id": 6,
            "name": 'iPhone 6 Plus',
            "model_name": 'iPhone-6-Plus',
            "sName": 'iPhone 6 Plus',
            "image": 'apple.svg',
            "alt": 'iPad Repair Shop Near Me',
            "isChecked": false
        },
        {
            "id": 5,
            "name": 'iPhone 6',
            "model_name": 'iPhone-6',
            "sName": 'iPhone 6',
            "image": 'apple.svg',
            "alt": 'iPad Repair Shop Near Me',
            "isChecked": false
        },
        {
            "id": 4,
            "name": 'iPhone SE',
            "model_name": 'iPhone-SE',
            "sName": 'iPhone SE',
            "image": 'apple.svg',
            "alt": 'iPad Repair Shop Near Me',
            "isChecked": false
        },
        {
            "id": 3,
            "name": 'iPhone 5s',
            "model_name": 'iPhone-5s',
            "sName": 'iPhone 5s',
            "image": 'apple.svg',
            "alt": 'iPad Repair Shop Near Me',
            "isChecked": false
        },
        {
            "id": 2,
            "name": 'iPhone 5c',
            "model_name": 'iPhone-5c',
            "sName": 'iPhone 5c',
            "image": 'apple.svg',
            "alt": 'iPad Repair Shop Near Me',
            "isChecked": false
        },
        {
            "id": 1,
            "name": 'iPhone 5',
            "model_name": 'iPhone-5',
            "sName": 'iPhone 5',
            "image": 'apple.svg',
            "alt": 'iPad Repair Shop Near Me',
            "isChecked": false
        },

    ] 
    return result;
};

export const _iPadJSON = () => {
    var result = [
        {
            "id": 1,
            "name": 'iPad',
            "model_name": 'iPad',
            "sName": 'iPad',
            "image": 'apple.svg',
            "alt": 'iPhone Repair Shop Near Me',
            "isChecked": false
        },
        {
            "id": 2,
            "name": 'iPad Air',
            "model_name": 'iPad-Air',
            "sName": 'iPad Air',
            "image": 'apple.svg',
            "alt": 'Apple Watch Repair Shop Near Me',
            "isChecked": false
        },
        {
            "id": 3,
            "name": 'iPad Mini',
            "model_name": 'iPad-Mini',
            "sName": 'iPad Mini',
            "image": 'apple.svg',
            "alt": 'iPad Repair Shop Near Me',
            "isChecked": false
        },
        {
            "id": 4,
            "name": 'iPad Pro',
            "model_name": 'iPad-Pro',
            "sName": 'iPad Pro',
            "image": 'apple.svg',
            "alt": 'MacBook Watch Repair Shop Near Me',
            "isChecked": false
        }
    ] 
    return result;
};

export const _macBookJSON = () => {
    var result = [
        {
            "id": 1,
            "name": 'MacBook',
            "model_name": 'MacBook',
            "sName": 'MacBook',
            "image": 'apple.svg',
            "alt": 'iPhone Repair Shop Near Me',
            "isChecked": false
        },
        {
            "id": 4,
            "name": 'MacBook Pro Retina',
            "model_name": 'MacBook-Pro-Retina',
            "sName": 'MacBook Pro Retina',
            "image": 'apple.svg',
            "alt": 'MacBook Watch Repair Shop Near Me',
            "isChecked": false
        },
        {
            "id": 2,
            "name": 'MacBook Pro',
            "model_name": 'MacBook-Pro',
            "sName": 'MacBook Pro',
            "image": 'apple.svg',
            "alt": 'Apple Watch Repair Shop Near Me',
            "isChecked": false
        },
        {
            "id": 3,
            "name": 'MacBook Air',
            "model_name": 'MacBook-Air',
            "sName": 'MacBook Air',
            "image": 'apple.svg',
            "alt": 'iPad Repair Shop Near Me',
            "isChecked": false
        }
    ] 
    return result;
};

export const _totalModels = () => {
    var result = [
        {
            "id": 1,
            "model_name": 'Apple-Watch-Series-1'
        },
        {
            "id": 2,
            "model_name": 'Apple-Watch-Series-2'
        },
        {
            "id": 3,
            "model_name": 'Apple-Watch-Series-3'
        },
        {
            "id": 4,
            "model_name": 'Apple-Watch-Series-4'
        },
        {
            "id": 5,
            "model_name": 'Apple-Watch-Series-5'
        },
        {
            "id": 6,
            "model_name": 'Apple-Watch-Series-1'
        },
        {
            "id": 7,
            "model_name": 'Apple-Watch-Series-2'
        },
        {
            "id": 8,
            "model_name": 'Apple-Watch-Series-3'
        },
        {
            "id": 9,
            "model_name": 'Apple-Watch-Series-4'
        },
        {
            "id": 10,
            "model_name": 'Apple-Watch-Series-5'
        },
        {
            "id": 11,
            "model_name": 'iPad'
        },
        {
            "id": 12,
            "model_name": 'iPad-Air'
        },
        {
            "id": 13,
            "model_name": 'iPad-Mini'
        },
        {
            "id": 14,
            "model_name": 'iPad-Pro'
        },
        {
            "id": 15,
            "model_name": 'MacBook'
        },
        {
            "id": 16,
            "model_name": 'MacBook-Pro'
        },
        {
            "id": 17,
            "model_name": 'MacBook-Air'
        },
        {
            "id": 18,
            "model_name": 'MacBook-Pro-Retina'
        },
        {
            "id": 19,
            "model_name": 'iPhone-5'
        },
        {
            "id": 20,
            "model_name": 'iPhone-5c'
        },
        {
            "id": 21,
            "model_name": 'iPhone-5s'
        },
        {
            "id": 22,
            "model_name": 'iPhone-SE'
        },
        {
            "id": 23,
            "model_name": 'iPhone-6'
        },
        {
            "id": 24,
            "model_name": 'iPhone-6-Plus'
        },
        {
            "id": 25,
            "model_name": 'iPhone-6s'
        },
        {
            "id": 26,
            "model_name": 'iPhone-6s-Plus'
        },
        {
            "id": 27,
            "model_name": 'iPhone-7'
        },
        {
            "id": 28,
            "model_name": 'iPhone-7-Plus'
        },
        {
            "id": 29,
            "model_name": 'iPhone-8'
        },
        {
            "id": 30,
            "model_name": 'iPhone-8-Plus'
        },
        {
            "id": 31,
            "model_name": 'iPhone-X'
        },
        {
            "id": 32,
            "model_name": 'iPhone-XR'
        },
        {
            "id": 33,
            "model_name": 'iPhone-XS'
        },
        {
            "id": 34,
            "model_name": 'iPhone-XS-Max'
        },
        {
            "id": 35,
            "model_name": 'iPhone-11'
        },
        {
            "id": 36,
            "model_name": 'iPhone-11-Pro'
        },
        {
            "id": 37,
            "model_name": 'iPhone-11-Pro-Max'
        }
    ] 
    return result;
};

export const _iPadIssuesJson = () => {
    var result = [
        {
            "id": 1,
            "name": 'Screen/Display Repair & Replacement ',
            "isChecked": false
        },
        {
            "id": 2,
            "name": 'Battery Repair & Replacement ',
            "isChecked": false
        },
        {
            "id": 3,
            "name": 'Charging Flex/Strip Repair & Replacement ',
            "isChecked": false
        },
        {
            "id": 4,
            "name": 'Speaker/Ringer Repair & Replacement ',
            "isChecked": false
        },
        {
            "id": 5,
            "name": 'Mic Repair & Replacement ',
            "isChecked": false
        },
        {
            "id": 6,
            "name": 'Ear Speaker Repair & Replacement ',
            "isChecked": false
        },
        {
            "id": 7,
            "name": 'Front Camera Repair & Replacement ',
            "isChecked": false
        },
        {
            "id": 8,
            "name": 'Rear Camera Repair & Replacement ',
            "isChecked": false
        },
        {
            "id": 9,
            "name": 'Light & Motion Sensor Repair & Replacement ',
            "isChecked": false
        },
        {
            "id": 10,
            "name": 'Headphone Repair & Replacement ',
            "isChecked": false
        },
        {
            "id": 11,
            "name": 'Power Button Repair & Replacement ',
            "isChecked": false
        },
        {
            "id": 12,
            "name": 'Volume Button Repair & Replacement ',
            "isChecked": false
        },
        {
            "id": 13,
            "name": 'Frame & Housing Repair & Replacement ',
            "isChecked": false
        },
        {
            "id": 14,
            "name": 'Other Problems - We will Contact you to find out more ',
            "isChecked": false
        }
    ] 
    return result;
};
export const _cityJson = () => {
    var result = [
        {
            "id": 1,
            "name": 'Hyderabad',
            "isChecked": false
        },
        {
            "id": 2,
            "name": 'Bengaluru',
            "isChecked": false
        },
        {
            "id": 3,
            "name": 'Mumbai',
            "isChecked": false
        },
        {
            "id": 4,
            "name": 'Delhi',
            "isChecked": false
        },
        {
            "id": 5,
            "name": 'Chennai',
            "isChecked": false
        },
        {
            "id": 6,
            "name": 'Kolkata',
            "isChecked": false
        },
        {
            "id": 7,
            "name": 'Pune',
            "isChecked": false
        },
        {
            "id": 8,
            "name": 'Gurgaon',
            "isChecked": false
        },
        {
            "id": 9,
            "name": 'Noida',
       
        },
        {
            "id": 10,
            "name": 'Faridabad',
        
        },
        {
            "id": 11,
            "name": '  Ahmedabad',
            "isChecked": false
        },
        {
            "id": 12,
            "name": 'Gandhinagar',
            "isChecked": false
        },
        {
            "id": 13,
            "name": 'Nagpur',
            "isChecked": false
        },
        {
            "id": 14,
            "name": 'Vizag',
            "isChecked": false
        }
    ] 
    return result;
};
export const _iPhoneIssuesJson = (data) => {
    var item1 = [{
        "id": 1,
        "name": 'Screen/Display Repair & Replacement ',
        "isChecked": false
    }]
    if(data == 'iPhone-8' || data == 'iPhone-SE' || data == 'iPhone-11-Pro-Max' || data == 'iPhone-11-Pro' || data == 'iPhone-11' || data == 'iPhone-XS-Max' || data == 'iPhone-XS' || data == 'iPhone-XR' || data == 'iPhone-X' || data == 'iPhone-8-Plus'){
        // item1.push({
        //     "id": 2,
        //     "name": 'Back Glass Repair & Replacement',
        //     "isChecked": false
        // })
        item1 = [{
            "id": 1,
            "name": 'Screen/Display Repair & Replacement ',
            "isChecked": false
        },
        {
            "id": 2,
            "name": 'Back Glass Repair & Replacement ',
            "isChecked": false
        }]
    }
    var item2 = [
        {
            "id": 3,
            "name": 'Battery Repair & Replacement ',
            "isChecked": false
        },
        {
            "id": 4,
            "name": 'Charging Flex/Strip Repair & Replacement ',
            "isChecked": false
        },
        {
            "id": 5,
            "name": 'Speaker/Ringer Repair & Replacement ',
            "isChecked": false
        },
        {
            "id": 6,
            "name": 'Mic Repair & Replacement ',
            "isChecked": false
        },
        {
            "id": 7,
            "name": 'Ear Speaker Repair & Replacement ',
            "isChecked": false
        },
        {
            "id": 8,
            "name": 'Front Camera Repair & Replacement ',
            "isChecked": false
        },
        {
            "id": 9,
            "name": 'Rear Camera Repair & Replacement ',
            "isChecked": false
        },
        {
            "id": 10,
            "name": 'Light & Motion Sensor Repair & Replacement ',
            "isChecked": false
        },
        {
            "id": 11,
            "name": 'Headphone Repair & Replacement ',
            "isChecked": false
        },
        {
            "id": 12,
            "name": 'Power Button Repair & Replacement ',
            "isChecked": false
        },
        {
            "id": 13,
            "name": 'Volume Button Repair & Replacement ',
            "isChecked": false
        },
        {
            "id": 14,
            "name": 'Frame & Housing Repair & Replacement ',
            "isChecked": false
        },
        {
            "id": 15,
            "name": 'Other Problems - We will Contact you to find out more ',
            "isChecked": false
        }
    ] 
    var result = [...item1,...item2]
    return result;
};

export const _iWatchIssuesJson = () => {
    var result = [
        {
            "id": 1,
            "name": 'Apple Watch Screen/Display Repair & Replacement ',
            "isChecked": false
        },
        {
            "id": 2,
            "name": 'Apple Watch Battery Repair & Replacement ',
            "isChecked": false
        },
        {
            "id": 3,
            "name": 'Other Problems - We Will Contact you to find out more ',
            "isChecked": false
        }
    ] 
    return result;
};

export const _iMacIssuesJson = () => {
    var result = [
        {
            "id": 1,
            "name": 'MacBook Screen/Display Repair & Replacement ',
            "isChecked": false
        },
        {
            "id": 2,
            "name": 'MacBook Hard Disk Drive Repair & Replacement ',
            "isChecked": false
        },
        {
            "id": 3,
            "name": 'MacBook Motherboard Repair & Replacement ',
            "isChecked": false
        },
        {
            "id": 4,
            "name": 'MacBook RAM Addition, Repair & Replacement ',
            "isChecked": false
        },
        {
            "id": 5,
            "name": 'Mac OSX support',
            "isChecked": false
        },
        {
            "id": 6,
            "name": 'MacBook Battery Repair & Replacement ',
            "isChecked": false
        },
        {
            "id": 7,
            "name": 'MacBook Keyboard Repair & Replacement ',
            "isChecked": false
        },
        {
            "id": 8,
            "name": 'MacBook Camera Repair & Replacement ',
            "isChecked": false
        },
        {
            "id": 9,
            "name": 'MacBook Trackpad Repair & Replacement ',
            "isChecked": false
        },
        {
            "id": 10,
            "name": 'Other Problems - We will Contact you to find out more ',
            "isChecked": false
        }
    ] 
    return result;
};

export default {
    _iPadJSON,
    _watchJSON,
    _macBookJSON,
    _totalModels,
    _iPhoneJSON,
    _iPhoneIssuesJson,
    _iPadIssuesJson,
    _iMacIssuesJson
};